import { Component } from 'react'
import './OrderSummary.scss'
import SummaryItem from 'components/SummaryItem/SummaryItem'
import { formatPrice, numberToText } from 'utils/utils'
import { translateManager as t } from 'services/TranslateManager'
import NoTilesSelectedOrderSummary from './SummaryItems/NoTilesSelectedOrderSummary'
import PhotosOrderSummary from './PhotosOrderSummary'
import TaxSummaryItem from './SummaryItems/TaxSummaryItem'

class OrderSummary extends Component {
  renderSummaryItems() {
    const { data } = this.props
    const taxSummaryItems = data.taxesDetailed?.map((tax) => {
      return (
        <TaxSummaryItem
          tax={tax.amount}
          taxName={tax.name}
          key={tax.name}
          currency={data.currency}
        />
      )
    })
    let creditUsed
    if (data.creditUsed && data.creditUsed !== 0) {
      creditUsed = (
        <SummaryItem
          text={t.get('order.checkout.payment_summary_rows.creditUsed')}
          testId="credit-summary-item"
        >
          -{formatPrice(data.creditUsed, data.currency, false, false)}
        </SummaryItem>
      )
    }

    if (!data?.totalItems) {
      return null
    }
    return (
      <PhotosOrderSummary
        {...this.props}
        taxSummaryItems={taxSummaryItems}
        creditUsed={creditUsed}
      />
    )
  }

  render() {
    const { data } = this.props

    if (data.tilesToAdd > 0) {
      return (
        <div className="order-summary-container">
          <div className="separator" />
          {data.tilesToAdd === 1 ? (
            <SummaryItem
              text={t.get(
                'order.checkout.payment_summary_rows.select_more_tiles_one'
              )}
            />
          ) : (
            <SummaryItem
              text={t.get(
                'order.checkout.payment_summary_rows.select_more_tiles_many',
                { v1: numberToText(data.tilesToAdd) }
              )}
            />
          )}
        </div>
      )
    }

    if (data.totalItems === 0) {
      return <NoTilesSelectedOrderSummary data={data} />
    }

    return (
      <div className="order-summary-container">{this.renderSummaryItems()}</div>
    )
  }
}

export default OrderSummary
